import React, { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import {
  adminLoginUrl,
  fetchAdminAuthStatus,
  getAdminToken,
  verifyAdminToken,
} from "../utils/adminAuth";

export default function RequireAdmin({ children }) {
  const location = useLocation();
  const [state, setState] = useState("checking");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const status = await fetchAdminAuthStatus();
        if (cancelled) return;
        if (!status.auth_required) {
          setState("ok");
          return;
        }
        const token = getAdminToken();
        if (!token) {
          setState("denied");
          return;
        }
        const valid = await verifyAdminToken(token);
        setState(valid ? "ok" : "denied");
      } catch {
        if (!cancelled) setState("denied");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  if (state === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-red-100">
        <p className="text-gray-600">Verifying admin access…</p>
      </div>
    );
  }

  if (state === "denied") {
    return <Navigate to={adminLoginUrl(location.pathname)} replace />;
  }

  return children;
}
